import React from 'react';
import cn from 'classnames';
import { string, element, bool } from 'prop-types';
import { t } from 'i18next';
import { useSelector } from 'react-redux';

import BenefitWarningBudget from '../BenefitWarningBudget';

import { arrayHasLength } from '~utils/array';

import styles from './styles.module.scss';

const DEFAULT_TAG = 'h2';

function SectionTitle({
  children,
  tag: Tag,
  title,
  actions,
  icon,
  className,
  titleClassName,
  hideSeparator,
  id,
  haveOneFree
}) {
  const loyaltyExperienceEnabled = useSelector(state => state.home.coreSettings?.loyaltyExperienceEnabled);
  const shoppingCart = useSelector(state => state.home?.shoppingCart);
  const hasCoupon = arrayHasLength(shoppingCart?.appliedPromos);

  return (
    <div className={cn('row middle section-title space-between', className)}>
      {icon && <i className={`m-right-2 ${icon}`} />}
      <Tag
        {...(id && { id })}
        className={cn('m-right-4', styles.text, titleClassName, { [styles.marginRight]: haveOneFree })}>
        {children || title}
      </Tag>
      {loyaltyExperienceEnabled && !hasCoupon && haveOneFree && (
        <BenefitWarningBudget className="m-right-4" text={t('MenuItem:chooseOneFree')} />
      )}
      {!hideSeparator && <hr className={styles.titleSeparator} />}
      {actions}
    </div>
  );
}

SectionTitle.defaultProps = {
  className: '',
  haveOneFree: false,
  hideSeparator: false,
  tag: DEFAULT_TAG,
  titleClassName: ''
};

SectionTitle.propTypes = {
  actions: element,
  className: string,
  haveOneFree: bool,
  hideSeparator: bool,
  icon: string,
  iconSvg: element,
  id: string,
  tag: string,
  title: string,
  titleClassName: string
};

export default SectionTitle;
